Object.defineProperty(exports, "__esModule", {
  value: true
});

var _aphrodite = require('aphrodite');

var aphrodite = _interopRequireWildcard(_aphrodite);

var _aphroditeInterfaceFactory = require('./aphroditeInterfaceFactory');

var _aphroditeInterfaceFactory2 = _interopRequireDefault(_aphroditeInterfaceFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = (0, _aphroditeInterfaceFactory2['default'])(aphrodite);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-with-styles-interface-aphrodite/lib/aphroditeInterface.js
// module id = 282
// module chunks = 4